import { render } from "./BannerMonth.vue?vue&type=template&id=7d445e6c&scoped=true"
import script from "./BannerMonth.vue?vue&type=script&lang=js"
export * from "./BannerMonth.vue?vue&type=script&lang=js"

import "./BannerMonth.vue?vue&type=style&index=0&id=7d445e6c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d445e6c"]])

export default __exports__